import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sidebarTranslate',
  standalone: true
})
export class SidebarTranslatePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'Application Management':
        return $localize`Application Management`;
      default:
        return value;
    }
  }
}
